<div class="error background-well">
  <div class="error-head">
    <h1 class="error-code">{{ errorCode }}</h1>
    <h2 class="error-title">{{ errorText | translate }}</h2>
  </div>

  <div class="error-body">
    <h3 class="error-hint-headline">{{ hintListHeadline | translate }}</h3>
    <ul class="error-hint-list">
      @for (item of hintList; track item) {
        <li class="error-hint-listitem">
          <span class="error-hint-listitem__inner">{{ item | translate }}</span>
        </li>
      }
    </ul>
  </div>
</div>
